import { useEffect, useState } from "react";
import axios from "axios";
import { sermons as mockSermons } from "../mock";
import { Play, X, Calendar, User, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Videos() {
  const [active, setActive] = useState(null);
  const [filter, setFilter] = useState("All");
  const [sermons, setSermons] = useState(mockSermons);
  useEffect(() => {
    axios.get(`${API}/sermons`).then(r => { if (r.data?.length) setSermons(r.data); }).catch(() => {});
  }, []);
  const series = ["All", ...new Set(sermons.map((s) => s.series).filter(Boolean))];
  const list = filter === "All" ? sermons : sermons.filter((s) => s.series === filter);

  return (
    <main className="pt-32 pb-24 bg-[#faf7f2]">
      <section className="relative py-20 bg-gradient-to-b from-[#0a2d38] to-[#0e5469] text-white -mt-32">
        <div className="max-w-5xl mx-auto px-6 md:px-12 pt-24 text-center">
          <Link to="/" className="inline-flex items-center gap-2 text-[#c8a36a] hover:text-[#f0d9a8] text-sm mb-6">
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
          <div className="text-[#c8a36a] uppercase tracking-[0.32em] text-xs font-semibold mb-3">Sermons & Messages</div>
          <h1 className="font-serif-display text-5xl md:text-6xl leading-[1.05]">
            Watch & be <span className="font-script italic text-[#f0d9a8]">filled.</span>
          </h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 mt-14">
        <div className="flex flex-wrap gap-2 mb-10 justify-center">
          {series.map((s) => (
            <button key={s} onClick={() => setFilter(s)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-colors ${
                filter === s ? "bg-[#0e5469] text-white" : "bg-white border border-[#e7dfd0] text-[#3b4d54] hover:border-[#c8a36a]"
              }`}>
              {s}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((s) => (
            <button key={s.id} onClick={() => setActive(s)} className="group text-left bg-white rounded-md overflow-hidden border border-[#e7dfd0] card-lift">
              <div className="relative aspect-video overflow-hidden">
                <img src={`https://i.ytimg.com/vi/${s.youtubeId}/hqdefault.jpg`} alt={s.title} className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-700" />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <div className="h-14 w-14 rounded-full bg-white/15 backdrop-blur border border-white/40 flex items-center justify-center group-hover:bg-[#c8a36a] group-hover:border-[#c8a36a]">
                    <Play className="h-5 w-5 text-white ml-0.5" />
                  </div>
                </div>
              </div>
              <div className="p-6">
                <div className="text-[10px] uppercase tracking-[0.28em] text-[#c8a36a] mb-2 font-semibold">{s.series}</div>
                <h3 className="font-serif-display text-xl text-[#0a2d38] mb-3 line-clamp-2">{s.title}</h3>
                <div className="flex items-center gap-4 text-xs text-[#5b6c72]">
                  <span className="flex items-center gap-1.5"><User className="h-3.5 w-3.5" />{s.speaker}</span>
                  <span className="flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5" />{s.date}</span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </section>

      {active && (
        <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setActive(null)}>
          <div className="relative w-full max-w-5xl aspect-video bg-black rounded-md overflow-hidden" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setActive(null)} className="absolute -top-12 right-0 text-white hover:text-[#c8a36a] flex items-center gap-2 text-sm">
              Close <X className="h-5 w-5" />
            </button>
            <iframe title={active.title} src={`https://www.youtube.com/embed/${active.youtubeId}?autoplay=1`} className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          </div>
        </div>
      )}
    </main>
  );
}
